import type { CategorySection as CategorySectionType } from '@ria-client/supergraph/roundup/types';
import { RoundupProductCard } from './roundup-product-card';

export interface CategorySectionProps {
  section: CategorySectionType;
  productPositionBase: number;
}

export function CategorySection({ section, productPositionBase }: CategorySectionProps) {
  const { description, eyebrowText, productCards, title } = section;

  return (
    <li
      className="mx-auto mb-8 flex max-w-full flex-col p-0 md:max-w-[82%]"
      data-testid="product-card-section"
    >
      {(title || eyebrowText) && (
        <div className="mb-3">
          {eyebrowText && <p className="typography-text-bold pb-2">{eyebrowText}</p>}
          {title && <p className="typography-text-large-bold">{title}</p>}
          {description && <p className="mt-1">{description}</p>}
        </div>
      )}
      <ul className="list-none p-0">
        {productCards.map((card, cardIndex) => (
          <RoundupProductCard
            card={card}
            cardIndex={cardIndex}
            key={`${card.marketplaceEntity.id}-${cardIndex}`}
            productPositionBase={productPositionBase}
          />
        ))}
      </ul>
    </li>
  );
}
